const FormResources = {

    form_data:  {
        building_id:        '',
        level_id:           '',
        area_id:            '',
        room_type_id:       '',
        floor_id:           '',
        cost_center_id:     '',
        patient:            false,
        fixtures:           '',
        time_adjustment:    '',
        work_group:         false,
        exclude_daily:      false,
        exclude_project:    false,
        closed:             false,
        essential_cleaning: false,
        daily_shift_1:      false,
        daily_shift_2:      false,
        daily_shift_3:      false,
        project_shift_1:    false,
        project_shift_2:    false,
        project_shift_3:    false,
        policing_shift_1:   false,
        policing_shift_2:   false,
        policing_shift_3:   false,
        previous_frequency: '',
        frequency:          '',
        calculating_daily_frequency_value: false,
        previous_policing_frequency: '',
        calculating_policing_frequency_value: false,
        policing_frequency: '',
        confirmation_daily: false,
        confirmation_policing: false,
        confirmation_project: false,
        confirmation_fields: [],

    },

   
    confirmation_form_format:[
        {
            css_class:  'col-md-4',
            type:       'checkbox',
            maxlength:  null,
            disabled:   false,
            step:       null,
            name:       'Closed:',
            model_name: 'confirmation_fields',
            value:      'closed',
            ref:        'closed_input',
            ref_alt:    'closed_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'checkbox',
            maxlength:  null,
            disabled:   false,
            step:       null,
            name:       'Essential cleaning:',
            ref:        'essential_cleaning_input',
            model_name: 'confirmation_fields',
            value:      'essential_cleaning',
            ref_alt:    'essential_cleaning_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'checkbox',
            maxlength:  null,
            disabled:   false,
            step:       null,
            name:       'Patient:',
            ref:        'patient_input',
            model_name: 'confirmation_fields',
            value:      'patient',
            ref_alt:    'patient_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'checkbox',
            maxlength:  null,
            disabled:   false,
            step:       null,
            name:       'Work group 2:',
            ref:        'work_group_2_input',
            model_name: 'confirmation_fields',
            value:      'work_group_2',
            ref_alt:    'work_group_2_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'checkbox',
            maxlength:  null,
            disabled:   false,
            step:       null,
            name:       'Excl. Dailys:',
            ref:        'excl_dailys_input',
            model_name: 'confirmation_fields',
            value:      'excl_dailys',
            ref_alt:    'excl_dailys_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'checkbox',
            maxlength:  null,
            disabled:   false,
            step:       null,
            name:       'Excl. Projects:',
            ref:        'excl_projects_input',
            model_name: 'confirmation_fields',
            value:      'excl_projects',
            ref_alt:    'excl_projects_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'checkbox',
            maxlength:  null,
            disabled:   false,
            step:       null,
            name:       'Daily shift(s):',
            ref:        'confirmation_daily_input',
            model_name: 'confirmation_fields',
            value:      'confirmation_daily',
            ref_alt:    'confirmation_daily_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'checkbox',
            maxlength:  null,
            disabled:   false,
            step:       null,
            name:       'Policing shift(s):',
            ref:        'confirmation_policing_input',
            model_name: 'confirmation_fields',
            value:      'confirmation_policing',
            ref_alt:    'confirmation_policing_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'checkbox',
            maxlength:  null,
            disabled:   false,
            step:       null,
            name:       'Project shift(s):',
            ref:        'confirmation_project_input',
            model_name: 'confirmation_fields',
            value:      'confirmation_project',
            ref_alt:    'confirmation_project_input_alt',
            required:   false,
        },
    ],

    confirmation_form_format_2: 
    [
        {
            css_class:  'col-md-4',
            type:       'checkbox',
            maxlength:  null,
            disabled:   false,
            step:       null,
            name:       'Default daily task:',
            ref:        'default_daily_task_input',
            model_name: 'confirmation_fields',
            value:      'default_daily_task',
            ref_alt:    'default_daily_task_input_alt',
            required:   false,
        },
    ],


    form_data_replacement:  {
        find:                   '',
        replace:                '',
        rooms_id:    [],
    },

    form_format_replacement:[
        {
            css_class:  'col-md-12',
            type:       'text',
            maxlength:  100,
            disabled:   false,
            step:       '',
            name:       'Find this:',
            model_name: 'find',
            ref:        'find_input',
            ref_alt:    'find_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-12',
            type:       'text',
            maxlength:  100,
            disabled:   false,
            step:       '',
            name:       'Replace with:',
            model_name: 'replace',
            ref:        'replace_input',
            ref_alt:    'replace_input_alt',
            required:   true,
        },
    ],

}

export default FormResources